import { ref, onMounted, watch, nextTick } from 'vue-demi';
const { debounce } = require('@futuweb/fego-bridge');
export function useHeaderHorizScroll({ horizontalTabRef, props }) {
    const shouldScroll = ref(true);

    /**
     * 横向滚动当前激活标题到中间
     */
    const scrollNavToHorizCenter = debounce(() => {
        if (!horizontalTabRef.value) {
            return;
        }
        if (!shouldScroll.value) {
            return;
        }
        const parent = horizontalTabRef.value.querySelector('.horizontal-anchor-tab-header-real');
        const child = parent.querySelector('.horizontal-anchor-tab-part.active');
        const parentRect = parent.getBoundingClientRect();
        const childRect = child.getBoundingClientRect();
        const scrollLeft = child.offsetLeft + childRect.width / 2 - parentRect.width / 2;
        parent.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }, 50);

    const checkShouldScroll = () => {
        nextTick(() => {
            const horizontalTabHeader = horizontalTabRef.value?.querySelector('.horizontal-anchor-tab-header-real');
            const isScrollable =
                horizontalTabHeader && horizontalTabHeader.scrollWidth > horizontalTabHeader.offsetWidth;
            shouldScroll.value = isScrollable;
        });
    };

    watch(
        () => props.tpl,
        () => {
            checkShouldScroll();
        },
        {
            deep: true
        }
    );

    onMounted(() => {
        checkShouldScroll();
    });

    return {
        shouldScroll,
        scrollNavToHorizCenter
    };
}
